import { motion } from "framer-motion";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Luis Daniel",
    date: "22 Ene 2026",
    rating: 5,
    title: "Crecimiento real desde Honor",
    quote:
      "Sin duda el crecimiento que he tenido desde que descubrí Honor Trading es demasiado. Muy recomendable para todo el que quiera realmente crecer en el trading.",
  },
  {
    name: "Anggelo",
    date: "31 Dic 2025",
    rating: 5,
    title: "10/10",
    quote:
      "Desde que entré a la academia, mi vida cambió. Grandes profesores y mentores como José, Jeff o Miguel han cambiado mi mentalidad y la manera de operar. No enseñan una estrategia: enseñan a leer el mercado.",
  },
  {
    name: "Moisés",
    date: "09 Ene 2026",
    rating: 5,
    title: "Seriedad del trading",
    quote:
      "Academia que vino a mostrar la seriedad del trading, a enseñar cómo aprender paso a paso con las herramientas que Honor Trading tiene para mejorar cada día. La mejor sin duda alguna.",
  },
  {
    name: "Erick",
    date: "30 Dic 2025",
    rating: 5,
    title: "Lo mejor en tecnología",
    quote:
      "Lo mejor que he visto en tecnología, no hay ninguna academia que tenga la tecnología que han puesto a mi servicio. Además la forma de trabajar militar es justo lo que se requiere para ser rentable en esta industria.",
  },
  {
    name: "Alejandra",
    date: "08 Ene 2026",
    rating: 5,
    title: "Estrategias claras",
    quote:
      "La Academia Honor Trading me ha enseñado estrategias muy claras y fáciles para cumplir con mi aprendizaje y llegar a mi rentabilidad. Cuenta con mentores calificados que te brindan asesoría personalizada.",
  },
  {
    name: "Jenireé",
    date: "01 Dic 2025",
    rating: 5,
    title: "Por fin una buena academia",
    quote:
      "Todo cambió al ingresar en Honor: respuestas oportunas del equipo, estrategias claras y con buen porcentaje de rentabilidad, información de valor. Todo lo necesario para cambiar la operativa de cualquiera.",
  },
];

const Stars = ({ n = 5 }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: n }).map((_, i) => (
      <Star key={i} className="w-3.5 h-3.5 fill-[#BEDD7D] text-[#BEDD7D]" />
    ))}
  </div>
);

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-32 bg-[#060806]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-16">
          <div className="max-w-3xl">
            <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
              / Testimonios Verificados
            </span>
            <h2 className="mt-6 font-display font-bold text-4xl md:text-6xl uppercase tracking-tight leading-none">
              La voz de los que{" "}
              <span className="italic text-[#BEDD7D]">avanzan</span>.
            </h2>
          </div>

          {/* Trustpilot score card */}
          <a
            href="https://www.trustpilot.com/review/honor.trading"
            target="_blank"
            rel="noopener noreferrer"
            className="group shrink-0 inline-flex items-center gap-4 px-5 py-4 rounded-2xl border border-[#3E4D36]/60 bg-[#1A2E1A]/40 hover:border-[#BEDD7D]/60 transition-all"
            data-testid="trustpilot-score"
          >
            <div className="flex flex-col">
              <div className="text-[10px] font-display uppercase tracking-[0.3em] text-white/50">
                Trustpilot
              </div>
              <div className="flex items-baseline gap-2 mt-1">
                <span className="font-display font-bold text-3xl text-white">4.8</span>
                <span className="text-xs text-white/50 font-body">/5</span>
              </div>
            </div>
            <div className="h-10 w-px bg-[#3E4D36]/60" />
            <div className="flex flex-col">
              <Stars />
              <span className="mt-1 text-[10px] font-display uppercase tracking-[0.2em] text-[#BEDD7D] group-hover:text-white transition-colors">
                52 reseñas reales
              </span>
            </div>
          </a>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name + i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1 }}
              className="relative p-6 md:p-7 rounded-2xl bg-[#1A2E1A]/30 border border-[#3E4D36]/50 hover:border-[#BEDD7D]/40 transition-all flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <div className="flex items-center justify-between mb-4">
                <Stars n={t.rating} />
                <span className="text-[10px] font-display uppercase tracking-widest text-white/40">
                  {t.date}
                </span>
              </div>
              <h3 className="font-display font-bold text-lg text-[#BEDD7D] uppercase tracking-tight leading-tight">
                {t.title}
              </h3>
              <p className="mt-3 text-white/80 font-body leading-relaxed text-[15px] flex-1">
                "{t.quote}"
              </p>
              <div className="mt-5 pt-4 border-t border-[#3E4D36]/40 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-[#BEDD7D]/15 border border-[#BEDD7D]/40 flex items-center justify-center font-display font-bold text-sm text-[#BEDD7D]">
                    {t.name.charAt(0)}
                  </div>
                  <div className="font-display font-bold text-sm text-white uppercase tracking-wide">
                    {t.name}
                  </div>
                </div>
                <span className="text-[10px] font-display uppercase tracking-[0.2em] text-white/40">
                  Trustpilot
                </span>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="https://www.trustpilot.com/review/honor.trading"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 border border-[#3E4D36] text-white font-display font-bold text-xs uppercase tracking-[0.25em] hover:bg-[#1A2E1A] hover:border-[#BEDD7D]/60 transition-all"
            data-testid="testimonials-see-all"
          >
            Ver todas las reseñas en Trustpilot →
          </a>
        </div>
      </div>
    </section>
  );
}
